import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

// create component styles
const useStyles = makeStyles(
  (theme) => {
    return {
      root: {
        color: theme.palette.text.primary,
      },

      small: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '20px',
      },

      normal: {
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '24px',
      },

      large: {
        fontSize: 22,
        fontWeight: 'bold',
        lineHeight: 'normal',
      },

      left: {
        textAlign: 'left',
      },

      right: {
        textAlign: 'right',
      },

      center: {
        textAlign: 'center',
      },
    };
  },
  {
    name: 'OMQHeadline',
  },
);

/**
 * Type for component properties.
 */
type HeadlineProps = {
  size?: 'small' | 'normal' | 'large';
  align?: 'left' | 'right' | 'center';
  className?: string;
  children: JSX.Element | string;
};

const TagNames = {
  small: 'h3',
  normal: 'h2',
  large: 'h1',
};

/**
 * Render given text as headline element.
 * Provides different sizes: `small`, `normal`, `large`'.
 * Default is `normal`.
 *
 * @param {string} size - size of headline
 * @param {string} align - alignment of headline
 * @param {string} [className] - additional class name
 * @param {JSX.Element} children - text/elements to render
 *
 * @returns {JSX.Element}
 */
export const Headline = ({
  children,
  size = 'normal',
  align = 'left',
  className,
}: HeadlineProps): JSX.Element => {
  const classes = useStyles();

  const Tag = TagNames[size];

  return (
    // @ts-ignore - typescript does not support these dynamic tag names
    <Tag className={clsx(classes.root, classes[size], classes[align], className)}>{children}</Tag>
  );
};
